/**
 * Normalize legal_agreements from API to the shape the frontend expects.
 * Backend may return short keys (terms, dpa, eula, aup, privacy); frontend expects
 * long keys (terms_of_service, data_processing_agreement, etc.).
 * Accepts either shape and returns { [longKey]: { agreed: boolean }, ... }.
 */

const BACKEND_TO_FRONTEND_KEYS = {
  terms: 'terms_of_service',
  dpa: 'data_processing_agreement',
  privacy: 'privacy_policy',
  eula: 'end_user_license_agreement',
  aup: 'acceptable_use',
  terms_of_service: 'terms_of_service',
  data_processing_agreement: 'data_processing_agreement',
  privacy_policy: 'privacy_policy',
  end_user_license_agreement: 'end_user_license_agreement',
  acceptable_use: 'acceptable_use',
  acceptable_use_policy: 'acceptable_use',
};

const FRONTEND_KEYS = [
  'terms_of_service',
  'data_processing_agreement',
  'privacy_policy',
  'end_user_license_agreement',
  'acceptable_use',
];

/**
 * @param {Record<string, { agreed?: boolean } | boolean>} raw - legal_agreements from API (backend or frontend key shape)
 * @returns {Record<string, { agreed: boolean }>} - normalized with long keys and .agreed
 */
export function normalizeLegalAgreementsFromApi(raw) {
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) {
    return Object.fromEntries(FRONTEND_KEYS.map((k) => [k, { agreed: false }]));
  }
  const result = {};
  for (const frontKey of FRONTEND_KEYS) {
    let agreed = false;
    for (const [backendKey, mappedFront] of Object.entries(BACKEND_TO_FRONTEND_KEYS)) {
      if (mappedFront !== frontKey) continue;
      const v = raw[backendKey];
      if (v != null) {
        agreed = agreed || (typeof v === 'object' ? v.agreed === true : v === true);
      }
    }
    result[frontKey] = { agreed };
  }
  return result;
}
